import ecommerceOrdersQueries from '@/api/modules/ecommerceOrdersQueries'
import { t } from '@/i18n'
import { notificationService } from '@/services/notificationService'
import { handleApiError } from '@/utils/apiHelpers'

class EcommerceOrdersService {
    async fetchOrders(queryString = '') {
        try {
            return await ecommerceOrdersQueries.fetchOrders(queryString)
        } catch (error) {
            handleApiError(error, t('orders.ecommerce.service.fetchOrdersError'))
            throw error
        }
    }

    async fetchOrder(orderId) {
        try {
            return await ecommerceOrdersQueries.fetchOrder(orderId)
        } catch (error) {
            handleApiError(error, t('orders.ecommerce.service.fetchOrderError'))
            throw error
        }
    }

    async fetchOrderStatuses() {
        try {
            return await ecommerceOrdersQueries.fetchOrderStatuses()
        } catch (error) {
            handleApiError(error, t('orders.ecommerce.service.fetchStatusesError'))
            throw error
        }
    }

    async fetchCountries() {
        try {
            return await ecommerceOrdersQueries.fetchCountries()
        } catch (error) {
            handleApiError(error, t('orders.ecommerce.service.fetchCountriesError'))
            throw error
        }
    }

    async fetchPrinters() {
        try {
            return await ecommerceOrdersQueries.fetchPrinters()
        } catch (error) {
            handleApiError(error, t('orders.ecommerce.service.fetchPrintersError'))
            throw error
        }
    }

    async updateOrder(orderData) {
        try {
            return await ecommerceOrdersQueries.updateOrder(orderData)
        } catch (error) {
            handleApiError(error, t('orders.ecommerce.service.updateOrderError'))
            throw error
        }
    }

    async addComment(commentData) {
        try {
            const response = await ecommerceOrdersQueries.addComment(commentData)
            notificationService.success(t('orders.ecommerce.service.addCommentSuccess'))
            return response
        } catch (error) {
            handleApiError(error, t('orders.ecommerce.service.addCommentError'))
            throw error
        }
    }

    async updateDelivery(deliveryId, payload) {
        try {
            return await ecommerceOrdersQueries.updateDelivery(deliveryId, payload)
        } catch (error) {
            handleApiError(error, t('orders.ecommerce.service.updateDeliveryError'))
            throw error
        }
    }

    async fetchToolboxTemplateContent(toolboxURI, templateId) {
        try {
            return await ecommerceOrdersQueries.fetchToolboxTemplateContent(toolboxURI, templateId)
        } catch (error) {
            handleApiError(error, t('orders.ecommerce.service.toolboxError'))
            throw error
        }
    }

    async printZPL(payload) {
        try {
            const response = await ecommerceOrdersQueries.printZPL(payload)
            notificationService.success(t('orders.ecommerce.service.printZPLSuccess'))
            return response
        } catch (error) {
            handleApiError(error, t('orders.ecommerce.service.printZPLError'))
            throw error
        }
    }
}

export const useEcommerceOrdersService = () => new EcommerceOrdersService()
